import React, { useState } from 'react'
import "./Navbar.css"
import { Link } from 'react-router-dom'
import user from "../../../Assets/Icons/user.png"
import user_1 from "../../../Assets/Icons/user_1.png"
import { useSelector } from 'react-redux'

const Navbar = () => {
 const {auth_info} = useSelector((state)=>state.Auth)
 const [isOpen, setIsOpen] = useState(false);
 const toggleMenu = () => setIsOpen(!isOpen);

  return (
    <header className='kiga-portal-navbar-header'>
      <div className=''>
         {/* 1. Hamburger Button in your Navbar */}
       <button className="hamburger" onClick={toggleMenu}>
        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="blue">
         <path fillRule="evenodd" d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM9 15a1 1 0 011-1h6a1 1 0 110 2h-6a1 1 0 01-1-1z" clipRule="evenodd" />
        </svg>
       </button>
        {/* 2. Overlay (darkens background when menu is open) */}
      {isOpen && <div className="overlay" onClick={toggleMenu}></div>}
            {/* 3. The Sidebar Menu */}
      <div className={`sidebar ${isOpen ? 'open' : ''}`}>
        <div className="sidebar-header">
          <div className="user-profile">
           <div className='user-info-acc-icons'> 
           {auth_info ? (<p>{auth_info?.email.slice(0,3)}</p>): (<Link to={null}><img src={user_1} alt='user-icons'/></Link>) }    
           </div>
           <div className='user-info-acc'>
            <div className="user-info">
              <p>Welcome, <strong>{auth_info ? (`${auth_info?.name.slice(0,4)}}`):(`${"Guest"}`) }</strong></p>
            </div>
             {auth_info ? (<div className="auth-buttons">
                <button className="btn-log">Log Out</button>
              </div>):(
              <div className="auth-buttons">
                <button className="btn-log">Log In</button>
              </div>
            ) } 
           </div>
           <div className=''>
           <button className="close-btn" onClick={toggleMenu}>✕</button>
           </div>
          </div>
          <nav className="sidebar-nav">
          <div className="nav-item location">📍 K.I.G.A <span>⌄</span></div>
          <div className="nav-item">🏠 Home</div>
          <div className="nav-item">👥 Bookings</div>
          <div className="nav-item">👤 My Account</div>
          <div className="nav-item">📢 News</div>
          <div className="nav-item">••• More <span>⌄</span></div>
        </nav>
        <div className="sidebar-footer">
          <div className="nav-item">🌐 Visit Website</div>
          <div className="privacy">Privacy Policy</div>
        </div>
      </div>
      </div>
      </div>
      <div className='kiga-portal-navbar-header-links'>
       <div className='kiga-portal-navbar-header-links-booking'><Link to='/portal/booking'>Booking</Link></div>
       <div className='kiga-portal-navbar-header-links-account'><Link to='/portal/dashboard/account'>My Account</Link></div>
       <div className='kiga-portal-navbar-header-links-news'><Link to={null}>News</Link></div>
      </div>
      <div className='kiga-portal-navbar-header-logs'>
       <img src="/images/logo2.png" alt='logo'/>
      </div>
      <div className='kiga-portal-navbar-header-info'>
        <div className='kiga-portal-navbar-header-info-para'> 
          <p>Kigali Internationl Gymnastics Academy</p>
          <p>Xscape, Colorado Way, • Castleford, YORKSHIRE WF10 4TA</p>
          <p>07700 139979 • Visit Website</p>
        </div>
         <div className='kiga-portal-navbar-header-info-account-icons'>
         {auth_info ? (<p>{auth_info?.email.slice(0,3)}</p>): (<Link to='/login'><img src={user_1} alt='user-icons'/></Link>) }
         </div>
        </div>
    </header>
  )
}

export default Navbar